<template>
  <div class="home-banner">
    <div class="banner-left">
      <homeCategory :categories="categoryList" :loading="categoryLoading" @select="onCategorySelect" />
    </div>
    <div class="banner-center">
      <div class="loading-container" v-if="carouselLoading">
        <i class="loading-icon"></i>
      </div>
      <homeCarousel v-else :courses="carouselList" @select="onCarouselSelect" />
    </div>
    <div class="banner-right">
      <homeNotice :notices="homeNoticeList" :loading="noticeLoading" @more="onNoticeMore" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HomeCategory from './homeCategory.vue'
import HomeCarousel from './homeCarousel.vue'
import HomeNotice from './homeNotice.vue'

export default {
  name: 'HomeBanner',
  components: { HomeCategory, HomeCarousel, HomeNotice },
  data () {
    return {
      carouselLoading: false,
      categoryLoading: false,
      noticeLoading: false
    }
  },
  computed: {
    ...mapState(['categoryList', 'carouselList', 'homeNoticeList', 'queryUserPromise'])
  },
  mounted () {
    this.queryUserPromise && this.queryUserPromise.then(() => {
      this.loadData()
    })
  },
  methods: {
    ...mapActions(['queryCategoryTree', 'queryCarouselCourses', 'queryHomeNoticeList']),
    loadData () {
      this.carouselLoading = true
      this.noticeLoading = true
      this.categoryLoading = true
      Promise.all([
        this.queryCategoryTree(),
        this.queryCarouselCourses(),
        this.queryHomeNoticeList()
      ]).finally(() => {
        this.carouselLoading = false
        this.noticeLoading = false
        this.categoryLoading = false
      })
    },
    onCategorySelect () {},
    onCarouselSelect () {},
    onNoticeMore () {}
  }
}
</script>

<style lang="scss" scoped>
.home-banner {
  display: flex;
  overflow: hidden;
  margin-top: 20px;
  min-height: 360px;
  gap: 20px;

  .banner-left {
    flex: 0 0 200px;
    background: #fff;
    border-radius: 8px;
  }

  .banner-center {
    flex: 1;
    min-width: 0;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    .loading-container {
      text-align: center;
      .loading-icon {
        display: inline-block;
        background: url(../assets/img/loading.gif) no-repeat;
        background-size: 100%;
        width: 50px;
        height: 50px;
      }
    }
  }

  .banner-right {
    flex: 0 0 260px;
    background: #fff;
    border-radius: 8px;
  }
}
</style>
